// Importación de assets personalizados (Basado en la imagen proporcionada)
import aReformar from "../icons/qualities/A reformar.svg";
import accesiblePMR from "../icons/qualities/Accesible PMR.svg";
import agricola from "../icons/qualities/Agricola.svg";
import aireAcondicionado from "../icons/qualities/Aire Acondicionado.svg";
import alarmaInterior from "../icons/qualities/Alarma interior.svg";
import alarmaPerimetral from "../icons/qualities/Alarma Perimetral.svg";
import alturaLibre from "../icons/qualities/Altura Libre.svg";
import amueblada from "../icons/qualities/Amueblada.svg";
import andaluz from "../icons/qualities/Andaluz.svg";
import armero from "../icons/qualities/Armero.svg";
import ascensor from "../icons/qualities/Ascensor.svg";
import aspiracionCentralizada from "../icons/qualities/Aspiracion centralizada.svg";
import banio from "../icons/qualities/Baño.svg";
import bodega from "../icons/qualities/Bodega.svg";
import brandedDesign from "../icons/qualities/Branded Design.svg";
import buenaConservacion from "../icons/qualities/Buena conservacion.svg";
import bus from "../icons/qualities/Bus.svg";
import cajaFuerte from "../icons/qualities/Caja fuerte.svg";
import calefaccionCentral from "../icons/qualities/Calefaccion Central.svg";
import calefaccionIndividual from "../icons/qualities/Calefaccion individual.svg";
import campoDeGolf from "../icons/qualities/Campo de golf.svg";
import carport from "../icons/qualities/Carport.svg";
import charca from "../icons/qualities/Charca.svg";
import cinegetica from "../icons/qualities/Cinegetica.svg";
import clasico from "../icons/qualities/Clasico.svg";
import cochera from "../icons/qualities/Cochera.svg";
import cocinaExterior from "../icons/qualities/Cocina exterior.svg";
import controlDeAccesos from "../icons/qualities/Control de accesos.svg";
import coworking from "../icons/qualities/Coworking.svg";
import dirtyKitchen from "../icons/qualities/Dirty kitchen.svg";
import edificioClasico from "../icons/qualities/Edificio clásico.svg";
import edificioExclusivo from "../icons/qualities/Edificio exclusivo de oficinas.svg";
import edificioMixto from "../icons/qualities/Edificio mixto.svg";
import entradaIndependiente from "../icons/qualities/Entrada independiente.svg";
import falsoTecho from "../icons/qualities/Falso techo.svg";
import fireplace from "../icons/qualities/Fireplace.svg";
import forestal from "../icons/qualities/Forestal.svg";
import ganadera from "../icons/qualities/Ganadera.svg";
import garaje from "../icons/qualities/Garaje.svg";
import gimnasio from "../icons/qualities/Gimnasio.svg";
import habitacion from "../icons/qualities/Habitación.svg";
import implantada from "../icons/qualities/Implantada.svg";
import instalacionesHipicas from "../icons/qualities/Instalaciones hípicas.svg";
import jardinPrivado from "../icons/qualities/Jardin privado.svg";
import lavanderia from "../icons/qualities/Lavanderia.svg";
import lounge from "../icons/qualities/Lounge.svg";
import metro from "../icons/qualities/Metro.svg";
import moderno from "../icons/qualities/Moderno.svg";
import montacargas from "../icons/qualities/Montacargas.svg";
import montania from "../icons/qualities/Montaña.svg";
import montaplatos from "../icons/qualities/Montaplatos.svg";
import naves from "../icons/qualities/Naves.svg";
import obraNueva from "../icons/qualities/Obra nueva.svg";
import otros from "../icons/qualities/Otros.svg";
import panicRoom from "../icons/qualities/Panic room.svg";
import panoramica from "../icons/qualities/Panoramica.svg";
import pantano from "../icons/qualities/Pantano.svg";
import piscinaInterior from "../icons/qualities/Piscina Interior.svg";
import piscina from "../icons/qualities/Piscina.svg";
import pistaDePadel from "../icons/qualities/Pista de Padel.svg";
import pistaDeTenis from "../icons/qualities/Pista de tenis.svg";
import porche from "../icons/qualities/Porche.svg";
import pozo from "../icons/qualities/Pozo.svg";
import puestosDeTrabajo from "../icons/qualities/Puestos de trabajo.svg";
import recreo from "../icons/qualities/Recreo.svg";
import reformado from "../icons/qualities/Reformado.svg";
import salaDeCine from "../icons/qualities/Sala de cine.svg";
import salidaDeHumos from "../icons/qualities/Salida de humos.svg";
import seguridad24h from "../icons/qualities/Seguridad 24h.svg";
import servicioDeConsergerie from "../icons/qualities/Servicio de Consergie.svg";
import servicioDePorteria from "../icons/qualities/Servicio de porteria.svg";
import showkitchen from "../icons/qualities/Showkitchen.svg";
import solarium from "../icons/qualities/Solarium.svg";
import spa from "../icons/qualities/Spa.svg";
import sueloRadiante from "../icons/qualities/Suelo radiante.svg";
import sueloTecnico from "../icons/qualities/Suelo tecnico.svg";
import suministroElectrico from "../icons/qualities/Suministro electrico.svg";
import terraza from "../icons/qualities/Terraza.svg";
import trastero from "../icons/qualities/Trastero.svg";
import urbanizacionCerrada from "../icons/qualities/Urbanizacion cerrada.svg";
import vallada from "../icons/qualities/Vallada.svg";
import vistasAlMar from "../icons/qualities/Vistas al mar.svg";
import viviendasSecundaria from "../icons/qualities/Viviendas secundaria.svg";

const IMG_STYLE = { width: "1.5em", height: "auto" };

export const qualityIcons = {
  // General / Estructural
  reformed: <img src={reformado} alt="" style={IMG_STYLE} />,
  toReform: <img src={aReformar} alt="" style={IMG_STYLE} />,
  lift: <img src={ascensor} alt="" style={IMG_STYLE} />,
  dumbwaiter: <img src={montaplatos} alt="" style={IMG_STYLE} />,
  liftTruck: <img src={montacargas} alt="" style={IMG_STYLE} />,
  airConditioning: <img src={aireAcondicionado} alt="" style={IMG_STYLE} />,
  centralHeating: <img src={calefaccionCentral} alt="" style={IMG_STYLE} />,
  individualHeating: (
    <img src={calefaccionIndividual} alt="" style={IMG_STYLE} />
  ),
  subfloorHeating: <img src={sueloRadiante} alt="" style={IMG_STYLE} />,
  falseCeiling: <img src={falsoTecho} alt="" style={IMG_STYLE} />,
  raisedFloor: <img src={sueloTecnico} alt="" style={IMG_STYLE} />,
  freeHeight: <img src={alturaLibre} alt="" style={IMG_STYLE} />,
  smokeOutlet: <img src={salidaDeHumos} alt="" style={IMG_STYLE} />,

  // Seguridad
  concierge: <img src={servicioDePorteria} alt="" style={IMG_STYLE} />,
  indoorAlarm: <img src={alarmaInterior} alt="" style={IMG_STYLE} />,
  outdoorAlarm: <img src={alarmaPerimetral} alt="" style={IMG_STYLE} />,
  fullHoursSecurity: <img src={seguridad24h} alt="" style={IMG_STYLE} />,
  accessControl: <img src={controlDeAccesos} alt="" style={IMG_STYLE} />,
  gunRack: <img src={armero} alt="" style={IMG_STYLE} />,
  strongBox: <img src={cajaFuerte} alt="" style={IMG_STYLE} />,
  panicRoom: <img src={panicRoom} alt="" style={IMG_STYLE} />,

  // Zonas Comunes / Exterior
  garage: <img src={garaje} alt="" style={IMG_STYLE} />,
  terrace: <img src={terraza} alt="" style={IMG_STYLE} />,
  storage: <img src={trastero} alt="" style={IMG_STYLE} />,
  swimmingPool: <img src={piscina} alt="" style={IMG_STYLE} />,
  indoorPoolCheck: <img src={piscinaInterior} alt="" style={IMG_STYLE} />,
  outdoorPoolCheck: <img src={piscina} alt="" style={IMG_STYLE} />,
  padelCourt: <img src={pistaDePadel} alt="" style={IMG_STYLE} />,
  tennisCourt: <img src={pistaDeTenis} alt="" style={IMG_STYLE} />,
  homeAutomation: <img src={otros} alt="" style={IMG_STYLE} />, // No hay un icono de domótica explícito en la imagen, se usa 'Otros' o podrías usar 'Aspiración centralizada'
  centralVacuum: <img src={aspiracionCentralizada} alt="" style={IMG_STYLE} />,
  gym: <img src={gimnasio} alt="" style={IMG_STYLE} />,
  privateGarden: <img src={jardinPrivado} alt="" style={IMG_STYLE} />,
  solarium: <img src={solarium} alt="" style={IMG_STYLE} />,
  outdoorKitchen: <img src={cocinaExterior} alt="" style={IMG_STYLE} />,
  carPort: <img src={carport} alt="" style={IMG_STYLE} />,
  lounge: <img src={lounge} alt="" style={IMG_STYLE} />,
  fireplace: <img src={fireplace} alt="" style={IMG_STYLE} />,

  // Baños / Interior
  qualityBathrooms: <img src={banio} alt="" style={IMG_STYLE} />,
  bathrooms: <img src={banio} alt="" style={IMG_STYLE} />,
  showKitchen: <img src={showkitchen} alt="" style={IMG_STYLE} />,
  dirtyKitchen: <img src={dirtyKitchen} alt="" style={IMG_STYLE} />,
  spa: <img src={spa} alt="" style={IMG_STYLE} />,
  movieTheater: <img src={salaDeCine} alt="" style={IMG_STYLE} />,
  wineCellar: <img src={bodega} alt="" style={IMG_STYLE} />,
  laundry: <img src={lavanderia} alt="" style={IMG_STYLE} />,
  firePlace: <img src={fireplace} alt="" style={IMG_STYLE} />,

  // Edificios
  exclusiveOfficeBuilding: (
    <img src={edificioExclusivo} alt="" style={IMG_STYLE} />
  ),
  mixedBuilding: <img src={edificioMixto} alt="" style={IMG_STYLE} />,
  classicBuilding: <img src={edificioClasico} alt="" style={IMG_STYLE} />,
  coworking: <img src={coworking} alt="" style={IMG_STYLE} />,

  // Estado / Otros
  implanted: <img src={implantada} alt="" style={IMG_STYLE} />,
  furnished: <img src={amueblada} alt="" style={IMG_STYLE} />,
  separateEntrance: <img src={entradaIndependiente} alt="" style={IMG_STYLE} />,
  accessiblePMR: <img src={accesiblePMR} alt="" style={IMG_STYLE} />,
  goodConservation: <img src={buenaConservacion} alt="" style={IMG_STYLE} />,
  newConstruction: <img src={obraNueva} alt="" style={IMG_STYLE} />,
  brandedDesign: <img src={brandedDesign} alt="" style={IMG_STYLE} />,
  conciergeService: (
    <img src={servicioDeConsergerie} alt="" style={IMG_STYLE} />
  ),
  gatedCommunity: <img src={urbanizacionCerrada} alt="" style={IMG_STYLE} />,

  // Rústico / Vistas
  agricultural: <img src={agricola} alt="" style={IMG_STYLE} />,
  hunting: <img src={cinegetica} alt="" style={IMG_STYLE} />,
  forestry: <img src={forestal} alt="" style={IMG_STYLE} />,
  livestock: <img src={ganadera} alt="" style={IMG_STYLE} />,
  rusticOther: <img src={otros} alt="" style={IMG_STYLE} />,
  warehouses: <img src={naves} alt="" style={IMG_STYLE} />,
  secondaryHousing: <img src={viviendasSecundaria} alt="" style={IMG_STYLE} />,
  equestrianFacilities: (
    <img src={instalacionesHipicas} alt="" style={IMG_STYLE} />
  ),
  electricSupply: <img src={suministroElectrico} alt="" style={IMG_STYLE} />,
  pond: <img src={charca} alt="" style={IMG_STYLE} />,
  reservoir: <img src={pantano} alt="" style={IMG_STYLE} />,
  well: <img src={pozo} alt="" style={IMG_STYLE} />,
  recess: <img src={recreo} alt="" style={IMG_STYLE} />,
  fenced: <img src={vallada} alt="" style={IMG_STYLE} />,
  porch: <img src={porche} alt="" style={IMG_STYLE} />,
  seaViews: <img src={vistasAlMar} alt="" style={IMG_STYLE} />,
  panoramicView: <img src={panoramica} alt="" style={IMG_STYLE} />,
  golfCourseView: <img src={campoDeGolf} alt="" style={IMG_STYLE} />,
  mountainView: <img src={montania} alt="" style={IMG_STYLE} />,

  // Otros campos detectados en imagen
  modernStyle: <img src={moderno} alt="" style={IMG_STYLE} />,
  classicStyle: <img src={clasico} alt="" style={IMG_STYLE} />,
  andaluzStyle: <img src={andaluz} alt="" style={IMG_STYLE} />,
  metro: <img src={metro} alt="" style={IMG_STYLE} />,
  bus: <img src={bus} alt="" style={IMG_STYLE} />,
  jobPositions: <img src={puestosDeTrabajo} alt="" style={IMG_STYLE} />,
};
